import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useApp();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = match[1];
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/home");
        navigate("/home", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg)] text-[var(--text-secondary)]">
      <div className="flex items-center gap-3">
        <span className="w-2 h-2 rounded-full bg-[var(--accent)] animate-pulse"></span>
        <span className="tracking-wide uppercase text-xs">Signing you in…</span>
      </div>
    </div>
  );
}
